import { Component, OnDestroy, OnInit } from '@angular/core';

import { Subscription } from 'rxjs';
import { CookieService } from 'ngx-cookie';

import { HelperService, ACLService, DataService } from 'app/services';
import { DialogService } from 'primeng/dynamicdialog';
import { findIndex } from 'lodash';

@Component({
  selector: 'app-dashboard',
  templateUrl: './master-layout.component.html',
  styleUrls: ['./master-layout.component.scss'],
  providers: [DialogService],
})
export class MasterLayoutComponent implements OnInit, OnDestroy {
  navItems: any[] = [];
  companyType: string;
  enableAptDropdown: boolean = false;
  enableRoDropdown: boolean = false;
  enableInvite: boolean = false;

  dataServiceSub: Subscription;
  routerServiceSub: Subscription;
  isAppleDevice: boolean = false;

  constructor(private helperService: HelperService, private cookieService: CookieService, private dataService: DataService, private aclService: ACLService) {}

  async ngOnInit() {
    this.isAppleDevice = this.helperService.isAppleDevice();
    this.setNavbarLink();
    this.setDataService();
  }

  ngOnDestroy(): void {
    this.dataServiceSub.unsubscribe();
  }

  setNavbarLink() {
    const token = this.cookieService.getObject('alpat');
    this.companyType = this.helperService.getCompany().companyType;

    if (token) {
      const data = this.helperService.jwtDecode(token);

      if (data) {
        const { role } = this.helperService.getCompany();

        this.navItems = this.helperService.deepCopy(this.aclService.getNav(this.helperService.jwtDecode(token).role));

        if (['onboarder', 'engg', 'sales'].includes(role)) {
          this.navItems = this.navItems.filter(({ navId }) => navId !== 'users');
        }
      }
    }
  }

  setDataService() {
    this.setFlaggedColumn();
    this.dataServiceSub = this.dataService.getData().subscribe(({ data }) => {
      if (!data) return;

      const { key } = data;

      if (key === 'company-appdata-updated') {
        this.setFlaggedColumn();
        this.dataServiceSub.unsubscribe();
      }
    });
  }

  setFlaggedColumn() {
    if (this.dataService.isInventoryEnabled || this.dataService.isTireStorageEnabled || this.dataService.isReturnFeatureEnabled) {
      const inventoryTab = {
        name: 'Inventory',
        navId: 'inventory',
        url: '/inventory/parts-return-list',
        icon: 'fal fa-boxes',
        active: 'active-lists',
        activeLinkId: 'inventory',
        permitted: true,
      };

      if (this.dataService.isInventoryEnabled) {
        inventoryTab.url = '/inventory/stock';
      } else if (this.dataService.isTireStorageEnabled) {
        inventoryTab.url = '/inventory/tire-storage';
      }

      if (findIndex(this.navItems, { navId: 'inventory' }) === -1) {
        this.navItems.splice(5, 0, inventoryTab);
      }
    }

    if (this.dataService.isMarketingEnabled && findIndex(this.navItems, { navId: 'marketing' }) === -1) {
      this.navItems.splice(6, 0, {
        name: `${this.dataService.isCRMDashboardEnabled ? 'CRM' : 'Marketing'}`,
        navId: 'marketing',
        url: `${this.dataService.isCRMDashboardEnabled ? '/marketing/marketing-dashboard' : '/marketing/campaign'}`,
        icon: 'fal fa-megaphone',
        active: 'active-marketing',
        activeLinkId: 'marketing',
        permitted: true,
      });
    }
    if (this.dataService.isUserCenterEnabled  && findIndex(this.navItems, { navId: 'userCenter' }) === -1) {
     this.navItems.splice(9, 0, {
        name: 'User Center',
        navId: 'userCenter',
        url: '/user-center',
        icon: 'fal fa-chalkboard-teacher',
        active: 'active-userCenter',
        activeLinkId: 'userCenter',
        permitted: true,
      });
    }
  }

  setUpApt() {
    this.enableAptDropdown = true;
  }

  // Enabke setupRo
  setUpRo() {
    this.enableRoDropdown = true;
  }

  // Enabke setupInvite
  setUpInvite() {
    this.enableInvite = true;
  }

  disableApt() {
    this.enableAptDropdown = false;
    this.enableRoDropdown = false;
    this.enableInvite = false;
  }
}
